import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function MercadoTrabalho() {
  const companies = [
    { name: 'Tech Solutions', logo: 'ri-building-line', sector: 'Tecnologia' },
    { name: 'Grupo Empresarial ABC', logo: 'ri-building-2-line', sector: 'Administração' },
    { name: 'Marketing Pro', logo: 'ri-store-line', sector: 'Marketing' },
    { name: 'Indústria XYZ', logo: 'ri-factory-line', sector: 'Indústria' },
    { name: 'Varejo Nacional', logo: 'ri-shopping-cart-line', sector: 'Varejo' },
    { name: 'Serviços Financeiros', logo: 'ri-bank-line', sector: 'Financeiro' },
    { name: 'Educação Plus', logo: 'ri-book-line', sector: 'Educação' },
    { name: 'Saúde & Bem-estar', logo: 'ri-heart-pulse-line', sector: 'Saúde' }
  ];

  const vagas = [
    {
      title: 'Assistente Administrativo',
      company: 'Grupo Empresarial ABC',
      location: 'São Paulo, SP',
      type: 'CLT',
      salary: 'R$ 2.500 - R$ 3.000',
      requirements: ['Ensino médio completo', 'Conhecimento em pacote Office', 'Boa comunicação']
    },
    {
      title: 'Analista de Marketing Digital',
      company: 'Marketing Pro',
      location: 'São Paulo, SP',
      type: 'CLT',
      salary: 'R$ 3.500 - R$ 4.500',
      requirements: ['Curso em Marketing ou áreas afins', 'Experiência com redes sociais', 'Google Ads']
    },
    {
      title: 'Desenvolvedor Junior',
      company: 'Tech Solutions',
      location: 'Remoto',
      type: 'CLT',
      salary: 'R$ 3.000 - R$ 4.000',
      requirements: ['Conhecimento em JavaScript', 'HTML/CSS', 'Vontade de aprender']
    },
    {
      title: 'Vendedor',
      company: 'Varejo Nacional',
      location: 'São Paulo, SP',
      type: 'CLT',
      salary: 'R$ 2.000 + comissões',
      requirements: ['Ensino médio completo', 'Experiência em vendas', 'Boa comunicação']
    },
    {
      title: 'Auxiliar de Produção',
      company: 'Indústria XYZ',
      location: 'Guarulhos, SP',
      type: 'CLT',
      salary: 'R$ 2.200 - R$ 2.800',
      requirements: ['Ensino médio completo', 'Disponibilidade de horário', 'Trabalho em equipe']
    },
    {
      title: 'Atendente de SAC',
      company: 'Serviços Financeiros',
      location: 'São Paulo, SP',
      type: 'CLT',
      salary: 'R$ 2.300 - R$ 2.800',
      requirements: ['Ensino médio completo', 'Boa comunicação', 'Empatia']
    }
  ];

  const testimonials = [
    {
      name: 'Carlos Eduardo',
      role: 'Assistente Administrativo',
      company: 'Grupo ABC',
      text: 'Fiz o curso Capacita e em 2 meses já estava empregado. O Instituto me preparou muito bem!',
      image: 'https://public.readdy.ai/ai/img_res/47826d85884d318f8470a14b2d205400.jpg'
    },
    {
      name: 'Mariana Santos',
      role: 'Analista de Marketing',
      company: 'Marketing Pro',
      text: 'O encaminhamento foi perfeito. A vaga era exatamente o que eu procurava e me sinto realizada!',
      image: 'https://readdy.ai/api/search-image?query=young%20professional%20brazilian%20woman%20business%20casual%20marketing%20professional%20smiling%20confident%20natural%20lighting%20warm%20tones%20professional%20headshot%20clean%20simple%20background%20authentic%20success&width=400&height=400&seq=work2&orientation=squarish'
    },
    {
      name: 'Felipe Oliveira',
      role: 'Desenvolvedor',
      company: 'Tech Solutions',
      text: 'Mudei de carreira com o apoio do Instituto. Hoje trabalho com o que amo e ganho bem melhor!',
      image: 'https://readdy.ai/api/search-image?query=young%20professional%20brazilian%20man%20tech%20worker%20developer%20casual%20attire%20smiling%20confident%20natural%20lighting%20warm%20tones%20professional%20headshot%20clean%20simple%20background%20authentic%20success&width=400&height=400&seq=work3&orientation=squarish'
    }
  ];

  const steps = [
    {
      number: '01',
      title: 'Capacitação',
      description: 'Participe de nossos cursos e programas de desenvolvimento',
      icon: 'ri-graduation-cap-line'
    },
    {
      number: '02',
      title: 'Preparação',
      description: 'Receba orientação para currículo, entrevistas e postura profissional',
      icon: 'ri-file-user-line'
    },
    {
      number: '03',
      title: 'Conexão',
      description: 'Conectamos você com empresas parceiras que buscam profissionais',
      icon: 'ri-links-line'
    },
    {
      number: '04',
      title: 'Contratação',
      description: 'Acompanhamos todo o processo até sua efetivação',
      icon: 'ri-briefcase-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Mercado de Trabalho
            </h1>
            <p className="text-xl text-white/90 leading-relaxed mb-8">
              Conectamos você com as melhores oportunidades profissionais
            </p>
            <div className="flex flex-wrap justify-center gap-8 text-left">
              <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-2xl border border-white/20">
                <p className="text-4xl font-bold text-yellow-400 mb-1">85%</p>
                <p className="text-white">Taxa de empregabilidade</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-2xl border border-white/20">
                <p className="text-4xl font-bold text-yellow-400 mb-1">+150</p>
                <p className="text-white">Empresas parceiras</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-2xl border border-white/20">
                <p className="text-4xl font-bold text-yellow-400 mb-1">+3000</p>
                <p className="text-white">Pessoas empregadas</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Como Funciona o Encaminhamento</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Um processo estruturado para garantir sua colocação no mercado
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100 h-full">
                  <div className="text-6xl font-bold text-blue-100 mb-4">{step.number}</div>
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mb-6">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h3>
                  <p className="text-slate-700 leading-relaxed">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-3xl text-blue-600"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Companies Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Empresas Parceiras</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Trabalhamos com empresas de diversos setores que confiam em nossos profissionais
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {companies.map((company, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg border border-slate-100 text-center hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${company.logo} text-3xl text-white`}></i>
                </div>
                <h3 className="font-bold text-slate-900 mb-2">{company.name}</h3>
                <p className="text-sm text-slate-600">{company.sector}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vagas Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Vagas Disponíveis</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Oportunidades atualizadas semanalmente para nossos alunos
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
            {vagas.map((vaga, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-all">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">{vaga.title}</h3>
                    <p className="text-slate-600 font-semibold">{vaga.company}</p>
                  </div>
                  <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                    {vaga.type}
                  </span>
                </div>
                <div className="flex flex-wrap gap-4 mb-4 text-sm text-slate-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line"></i>
                    {vaga.location}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-money-dollar-circle-line"></i>
                    {vaga.salary}
                  </span>
                </div>
                <div className="mb-4">
                  <p className="text-sm font-semibold text-slate-900 mb-2">Requisitos:</p>
                  <ul className="space-y-1">
                    {vaga.requirements.map((req, idx) => (
                      <li key={idx} className="text-sm text-slate-700 flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-green-600 mt-0.5"></i>
                        <span>{req}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <Link
                  to="/inscricoes"
                  className="block w-full bg-blue-600 text-white text-center px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition-all whitespace-nowrap cursor-pointer"
                >
                  Candidatar-se
                </Link>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <p className="text-slate-600 mb-4">
              <strong>Atenção:</strong> As vagas são exclusivas para alunos do Instituto Allcance
            </p>
            <Link
              to="/inscricoes"
              className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Quero ter acesso às vagas
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Quem Conseguiu Emprego</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Histórias reais de pessoas que transformaram suas carreiras
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100">
                <div className="flex items-center mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-bold text-slate-900">{testimonial.name}</h4>
                    <p className="text-sm text-slate-600">{testimonial.role}</p>
                    <p className="text-sm text-blue-600 font-semibold">{testimonial.company}</p>
                  </div>
                </div>
                <p className="text-slate-700 leading-relaxed italic mb-4">"{testimonial.text}"</p>
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Participate Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-slate-900 mb-4">Como Participar</h2>
              <p className="text-xl text-slate-600">
                Siga estes passos para ter acesso às vagas exclusivas
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl border border-blue-100">
              <ol className="space-y-6">
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                    1
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Inscreva-se em um de nossos programas</h4>
                    <p className="text-slate-700">Escolha o curso ou programa que mais se adequa ao seu perfil e objetivos</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                    2
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Complete sua capacitação</h4>
                    <p className="text-slate-700">Participe ativamente das aulas e atividades propostas</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                    3
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Prepare-se para o mercado</h4>
                    <p className="text-slate-700">Receba orientação sobre currículo, entrevistas e postura profissional</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                    4
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Receba as oportunidades</h4>
                    <p className="text-slate-700">Nossa equipe conectará você com vagas compatíveis com seu perfil</p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto para conquistar sua vaga?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Junte-se aos milhares de profissionais que já conquistaram seus objetivos através do Instituto Allcance.
          </p>
          <Link
            to="/inscricoes"
            className="inline-block bg-yellow-400 text-slate-900 px-10 py-5 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-2xl hover:shadow-yellow-400/50 whitespace-nowrap cursor-pointer"
          >
            Começar agora
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
